import { render, staticRenderFns } from "./MemberErrorList.vue?vue&type=template&id=8bf4ad24&scoped=true&"
import script from "./MemberErrorList.vue?vue&type=script&lang=js&"
export * from "./MemberErrorList.vue?vue&type=script&lang=js&"
import style0 from "./MemberErrorList.vue?vue&type=style&index=0&id=8bf4ad24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf4ad24",
  null
  
)

export default component.exports